var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"flex flex-col space-y-2 md:space-y-unset md:flex-row md:space-x-2 md:items-center md:space-y-0"},[_c('h1',{staticClass:"w-full font-semibold text-2xl uppercase tracking-wider break-all"},[_vm._v(" "+_vm._s(_vm.text)+" ")]),_vm._t("primaryAction"),_vm._t("secondaryAction")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }